import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import GamePage from './GamePage';
import ToPlay from "./toPlay";
import Panel from "./AdminPanel";
import Winn from "./winn";
import Leaders from "./leaders";
import Login from "./Login";
import LandingPage from "./LandingPage";
import AboutPage from "./AboutPage";
import CrmPanel from "./CrmPanel";
import PaymentSuccess from "./PaymentSuccess";
import MobilePlay from "./MobilePlay";
import ADRTU from "./ADRTU";
import Ihgfugh from "./ihgfugh";
// מודול הכדורגל — קוד עצמאי בתיקייה src/football.
// נטען רק כשנכנסים אליו (chunk נפרד), כדי לא להכביד על הבנדל הראשי.
const FootballPanel = lazy(() => import("./football/FootballPanel"));
const FootballBoard = lazy(() => import("./football/FootballBoard"));
const FootballDial = lazy(() => import("./football/FootballDial"));
const football = (Component) => (
  <Suspense fallback={<div dir="rtl" style={{ padding: 40, textAlign: "center", fontFamily: "'Varela Round', Rubik, Arial" }}>⚽ טוען...</div>}>
    <Component />
  </Suspense>
);


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/play/:gameId" element={<GamePage />} />
        <Route path="/toplay/:gameId" element={<ToPlay />} />
        <Route path="/Panel/endPay" element={<PaymentSuccess />} />
        <Route path="/panel/:userId" element={<Panel />} />
        <Route path="/panel" element={<Panel />} />
        <Route path="/login" element={<Login />} />
        <Route path="/ADRTU" element={<ADRTU />} />
        <Route path="/ihgfugh" element={<Ihgfugh />} />
        <Route path="/winn/:gameId" element={<Winn />} />
        <Route path="/leaders/:gameId" element={<Leaders />} />
        <Route path="/crm" element={<CrmPanel />} />
        <Route path="/m" element={<MobilePlay />} />
        <Route path="/m/:gameId" element={<MobilePlay />} />
        {/* כדורגל בטלפון */}
        <Route path="/football" element={football(FootballPanel)} />
        <Route path="/football/board/:matchId" element={football(FootballBoard)} />
        <Route path="/football/dial/:matchId" element={football(FootballDial)} />
      </Routes>
    </Router>
  );
}

export default App;
